import React from 'react';
import PropTypes from 'prop-types';
import styles from './FuneralHomeFooter.styl';
import _pick from 'lodash/pick';


const FuneralHomeFooter = props => {
  const {
    data: {data},
  } = props;

  if (data) {
    const {
      copyright: {text = null},
      locations = {},
      socials = [],
      styles: footerStyles = {},
    } = data;
    const copyrightText = text ? `${new Date().getFullYear()} ${text}` : null;
    const {corporate = null, locations: locationsLinks = []} = locations;

    const backgroundStyle = _pick(footerStyles, ['backgroundColor']);

    return (
      <div className={styles.FuneralFooterLarge} style={backgroundStyle}>
        <div className={styles.leftContent}>
          <div className={styles.copyright}>&copy; {copyrightText}</div>
          <nav className={styles.navLinks}>
            <span>
              {corporate}
              {locationsLinks.length > 0 ? ' | ' : null}
              {locationsLinks.map((obj, index) => { return (
                  <span key={index}>
                    <a href={obj.url} target={obj.target}>
                      {obj.name}
                    </a>
                    {index < locationsLinks.length -1 ? ' | ' : null}
                  </span>
                )
              })
            }
            </span>
          </nav>
          <nav className={styles.navLinks}>
            <span>
              {socials.map((obj, index) => (
                <a key={index} href={obj.url} target={obj.target}>
                  <img src={obj.backgroundImageUrl} style={{margin: '5px 10px 0 0', height: '20px'}}/>
                </a>
              ))}
            </span>
          </nav>
          <nav className={styles.navLinks}>
            <span>
              {data.menu.map((obj, index) => { return (
                  <span key={index}>
                    <a href={obj.url} target={obj.target}>
                      {obj.name}
                    </a>
                    {index < data.menu.length -1 ?
                    <span style={{paddingLeft: '20px', paddingRight: '20px'}}> | </span> :
                    null}
                  </span>
                )
              })
            }
            </span>
          </nav>
        </div>

        <div className={styles.rightContent}>
          <span dangerouslySetInnerHTML={{__html: data.disclaimer}} />
        </div>

      </div>
    );
  }
  const noData = {display: 'none'};

  return <div style={noData}>load error</div>;
};

FuneralHomeFooter.propTypes = {
  data: PropTypes.object,
};

export default FuneralHomeFooter;



// WEBPACK FOOTER //
// ./src/reactModules/shared/library/FuneralHomeFooter/FuneralHomeFooter.js